import { CircularProgress, Grid } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import api from 'api';
import { Field, Formik } from 'formik';
import { Notify } from 'utils';
import Fields from 'components/Fields';
import { Button } from 'components/Base';
import DropdownInput from 'components/Dropdown/Dropdown';
import { sortPlatforms } from 'pages/MpsHub/utils';

interface PlatformAvailabilityProps {
  data: any;
  classes: any;
  updateData: Function;
}

const PlatformAvailability = ({
  data,
  classes,
  updateData
}: PlatformAvailabilityProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [platformInput, setPlatformInput] = useState('');
  const [platforms, setPlatforms] = useState([]);
  const [selectedPlatforms, setSelectedPlatforms] = useState(
    data.platforms.map((platform: any) => ({ ...platform, is_checked: true }))
  );

  useEffect(() => {
    setIsLoading(true);
    api.getMetaPolicyPlatform().then(({ data }: any) => {
      setPlatforms(data);
      setIsLoading(false);
    });
  }, []);

  const addPlatform = (platform: any, selectedPlatforms: any[]) => {
    if (!platform.name) {
      return;
    }

    setSelectedPlatforms([
      ...selectedPlatforms,
      { ...platform, is_checked: true }
    ]);
  };

  return isLoading ? (
    <div className={classes.loaderWrapper}>
      <CircularProgress size="80px" />
    </div>
  ) : (
    <Formik
      enableReinitialize
      initialValues={{
        platform: '',
        selectedPlatforms
      }}
      onSubmit={values => {
        setIsSaving(true);

        api
          .updateMpsProviderPlatforms(
            data.id,
            values.selectedPlatforms
              .filter((selectedPlatform: any) => selectedPlatform.is_checked)
              .map((selectedPlatform: any) => ({
                ...selectedPlatform,
                platform_id:
                  selectedPlatform.platform_id ||
                  Number(selectedPlatform.value),
                provider: data.id
              }))
          )
          .then((response: any) => {
            updateData({ ...data, platforms: response.data });
            Notify.success('Platform availability updated successfully.');
          })
          .catch(() => {
            Notify.error('Platform availability could not be updated.');
          })
          .finally(() => {
            setIsSaving(false);
          });
      }}
    >
      {({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit}>
          <div>
            <div className={classes.row}>
              <div className={classes.label}>Select platform(s)</div>
              <div className={classes.fieldWrapper}>
                <DropdownInput
                  options={platforms.filter(
                    (platform: any) =>
                      !values.selectedPlatforms
                        .map((selectedPlatform: any) => selectedPlatform.name)
                        .includes(platform.name)
                  )}
                  label=""
                  onChange={(platform: any) => {
                    addPlatform(platform, values.selectedPlatforms);
                    setTimeout(() => setPlatformInput(''), 0);
                  }}
                  objectKey={'name'}
                  search={true}
                  value={platformInput}
                  required={false}
                />
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.title}>Platforms selected</div>
            </div>
            <Grid container>
              {sortPlatforms(selectedPlatforms).map(
                (platform: any, index: number) => (
                  <Grid key={index} item xs={6} className={classes.row}>
                    <div style={{ marginRight: '0.5rem' }}>
                      <Field
                        component={Fields.v2.Checkbox}
                        name={`selectedPlatforms[${index}].is_checked`}
                      />
                    </div>
                    {platform.name}
                  </Grid>
                )
              )}
            </Grid>
          </div>
          <div>
            <Button type="submit" disabled={isSaving} isLoading={isSaving}>
              Save
            </Button>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default PlatformAvailability;
